import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WelcomePage.css';

const WelcomePage = () => {
    const navigate = useNavigate();

    const options = [
        {
            title: 'Visit Our Website',
            description: 'Explore our company, services and projects.',
            action: () => navigate('/Home'),
            icon: '🌐',
        },
        {
            title: 'Internship for College Students',
            description: 'Gain practical industry experience through live projects, technical training, and mentorship.',
            action: () => navigate('/internship'),
            icon: '🎓',
        },
        {
            icon: '🤖',
            title: 'AI & Coding for School Students',
            description: 'Learn Coding, Python, Artificial Intelligence and Machine Learning through practical projects for students from Class 6 to 12.',
            action: () => navigate('/schoolcodingcourse'),
        },
       
        {
            title: 'AI & IT Courses',
            description: 'Explore AI, software development and IT courses.',
            action: () => navigate('/courses'),
            icon: '🤖',
        },
        {
            title: 'Computer Classes',
            description: 'Learn computer fundamentals and practical skills.',
            action: () => navigate('/computer-classes'),
            icon: '💻',
        },
        
        // {
        //     title: 'Our Clients',
        //     description: 'Discover our clients and the work we deliver.',
        //     action: () => navigate('/clients'),
        //     icon: '🤝',
        // },
    ];

    return (
        <div className="welcome-page">
            <div className="welcome-content">
                <h1>Welcome to A.P Tech Solution</h1>
                <p className="welcome-subtitle">
                    Choose an option to explore our services and learning programs.
                </p>

                <div className="welcome-grid">
                    {options.map((option) => (
                        <button
                            type="button"
                            className="welcome-card"
                            key={option.title}
                            onClick={option.action}
                        >
                            <span className="welcome-icon">{option.icon}</span>
                            <h2>{option.title}</h2>
                            <p>{option.description}</p>
                            <span className="welcome-link">Explore Now →</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WelcomePage;